import { UploadRepo } from "@/repos";

class UploadService {
    async upload(file) {
        let { data } = await UploadRepo.upload(file);
        return data;
    }
}

export default new UploadService();